import React from 'react';
import {Link} from 'gatsby';
import Breadcrumbs from '@homeaway/react-breadcrumbs';

export function truncateTitle(title) {
    const words = title.split(' ');
    return words.length > 4
        ? `${words.filter((w, i) => i < 4).join(' ')}...`
        : title;
}

export default function PureMediaCenterBreadcrumbs({
    homeTitle,
    archiveSlug,
    archiveYear,
    pressReleaseTitle,
    translations,
}) {
    const homeCrumb = {
        name: homeTitle,
        url: '',
        node: <Link to="/" />,
    };

    const archiveLabel = translations.pressReleases;
    const archiveCrumb = {
        name: archiveLabel,
        url: '',
        node: <Link to={`/${archiveSlug}/`} />,
    };

    const yearCrumb = {
        name: archiveYear,
        url: '',
        node: <Link to={`/${archiveSlug}/${archiveYear}/`} />,
    };

    const crumbs = [homeCrumb, archiveCrumb, yearCrumb];

    if (pressReleaseTitle) {
        crumbs.push({
            name: truncateTitle(pressReleaseTitle),
            url: '',
        });
    }

    return <Breadcrumbs crumbs={crumbs} />;
}
